// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  People,
  LocationAdd,
  User,
  Paintbucket,
  Category2,
  Filter,
  MoneyAdd,
  // Coffee,
  Cake,
  ArrowDown,
  // Signpost,
  BackSquare,
  UserTick,
  Unlock,
  WatchStatus,
  TruckFast,
  Strongbox,
  ProfileTick,
  UserAdd,
  SmsNotification,
  MirroringScreen
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  application: KyberNetwork,
  chat: Messages2,
  bees: People,
  staff: ProfileTick,
  notification: People,
  city: LocationAdd,
  vendor: User,
  user: UserAdd,
  role: UserAdd,
  screens: MirroringScreen,
  sponsors: UserTick,
  inventory: WatchStatus,
  flavor: Cake,
  banners: SmsNotification,
  purchase: ShoppingBag,
  grn: TruckFast,
  quality_check: Strongbox,
  update_purchase: Unlock,
  Products: Paintbucket,
  orders: MoneyAdd,
  return: BackSquare,
  category: Category2,
  promocode: ArrowDown,
  filter: Filter,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const flavors: NavItemType = {
  id: 'group-purchase',
  title: <FormattedMessage id="flavors Management" />,
  icon: icons.purchase,
  menu_id: 1,
  type: 'group',
  children: [
    {
      id: 'banners',
      title: <FormattedMessage id="Banners" />,
      type: 'collapse',
      icon: icons.banners,
      children: [
        {
          id: 'banners-list',
          title: <FormattedMessage id="Banners List" />,
          type: 'item',
          url: '/apps/banners/banners-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-Banners',
          title: <FormattedMessage id="Create Banner" />,
          type: 'item',
          url: '/apps/banners/add-new-Banners'
        },
        {
          id: 'slider-list',
          title: <FormattedMessage id="Slider List" />,
          type: 'item',
          url: '/apps/banners/slider-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-slider',
          title: <FormattedMessage id="Create Slider" />,
          type: 'item',
          url: '/apps/banners/add-new-slider'
        }
      ]
    },
    {
      id: 'recipees',
      title: <FormattedMessage id="Recipees" />,
      type: 'collapse',
      icon: icons.flavor,
      children: [
        {
          id: 'recipe',
          title: <FormattedMessage id="Recipe" />,
          type: 'collapse',
          children: [
            {
              id: 'recipe-list',
              title: <FormattedMessage id="Recipe list" />,
              type: 'item',
              url: '/apps/flavors/recipe-list',
              breadcrumbs: false
            },
            {
              id: 'add-new-recipe',
              title: <FormattedMessage id="Create Recipe" />,
              type: 'item',
              url: '/apps/flavors/add-new-recipe'
            }
          ]
        },
        {
          id: 'recipe-tags',
          title: <FormattedMessage id="Recipe Tags" />,
          type: 'collapse',
          children: [
            {
              id: 'recipe-tags-list',
              title: <FormattedMessage id="Recipe Tags List" />,
              type: 'item',
              url: '/apps/flavors/recipe-tags-list',
              breadcrumbs: false
            },
            {
              id: 'add-new-recipeTags',
              title: <FormattedMessage id="Create Recipe Tags" />,
              type: 'item',
              url: '/apps/flavors/add-new-recipeTags'
            },
            {
              id: 'recipe-group-list',
              title: <FormattedMessage id="Recipe Group List" />,
              type: 'item',
              url: '/apps/flavors/recipe-group-list',
              breadcrumbs: false
            },
            {
              id: 'add-new-recipeGroup',
              title: <FormattedMessage id="Create Recipe Tag Group" />,
              type: 'item',
              url: '/apps/flavors/add-new-recipeGroup'
            },
             {
              id: 'recipe-keyword-list',
              title: <FormattedMessage id="Recipe Keyword List" />,
              type: 'item',
              url: '/apps/flavors/recipe-keyword-list',
              breadcrumbs: false
            },
            {
              id: 'add-new-recipeKeyword',
              title: <FormattedMessage id="Create Recipe Keyword" />,
              type: 'item',
              url: '/apps/flavors/add-new-recipe-Keyword'
            }
          ]
        },
        {
          id: 'recipe-suitability',
          title: <FormattedMessage id="Recipe Suitability" />,
          type: 'collapse',
          children: [
            {
              id: 'recipe-suitability-list',
              title: <FormattedMessage id="Recipe Suitability List" />,
              type: 'item',
              url: '/apps/flavors/recipe-suitability-list',
              breadcrumbs: false
            },
            {
              id: 'add-new-recipeSuitability',
              title: <FormattedMessage id="Create Recipe Suitability" />,
              type: 'item',
              url: '/apps/flavors/add-new-recipeSuitability'
            },
           
          ]
        },
        {
          id: 'meal-type',
          title: <FormattedMessage id="Recipe Meal Type" />,
          type: 'collapse',
          children: [
            {
              id: 'meal-type-list',
              title: <FormattedMessage id="Recipe Meal Type List" />,
              type: 'item',
              url: '/apps/flavors/meal-type-list',
              breadcrumbs: false
            },
            {
              id: 'add-new-mealType',
              title: <FormattedMessage id="Create Recipe Meal Type" />,
              type: 'item',
              url: '/apps/flavors/add-new-mealType'
            },
          ]
        },
        {
          id: 'recipe-cuisine',
          title: <FormattedMessage id="Recipe Cuisine" />,
          type: 'collapse',
          children: [
            {
              id: 'recipe-cuisine-list',
              title: <FormattedMessage id="Recipe Cuisine List" />,
              type: 'item',
              url: '/apps/flavors/recipe-cuisine-list',
              breadcrumbs: false
            },
            {
              id: 'add-new-recipeCuisine',
              title: <FormattedMessage id="Create Recipe Cuisine" />,
              type: 'item',
              url: '/apps/flavors/add-new-recipeCuisine'
            },
          ]
        },
       
        {
          id: 'recipe-banners',
          title: <FormattedMessage id="Recipe Banners" />,
          type: 'collapse',
          children: [
            {
              id: 'recipeBanners-list',
              title: <FormattedMessage id="Banners List" />,
              type: 'item',
              url: '/apps/flavors/recipeBanners-list',
              breadcrumbs: false
            },
            {
              id: 'add-new-recipeBanners',
              title: <FormattedMessage id="Create Banner" />,
              type: 'item',
              url: '/apps/flavors/add-new-recipeBanners'
            },
            {
              id: 'recipeSlider-list',
              title: <FormattedMessage id="Slider List" />,
              type: 'item',
              url: '/apps/flavors/recipeSlider-list',
              breadcrumbs: false
            },
            {
              id: 'add-new-recipeSlider',
              title: <FormattedMessage id="Create Slider" />,
              type: 'item',
              url: '/apps/flavors/add-new-recipeSlider'
            }
          ]
        }
      ]
    },
    
  ]
};

export default flavors;
